// import "./App.css";

import { Route, Routes, useLocation } from "react-router-dom";
import AboutPage from "./pages/AboutPage";
import Login from "./pages/AuthPages/Login";
import SignUp from "./pages/AuthPages/SignUp";
import LandingPage from "./pages/LandingPage";
import Pricing from "./pages/Pricing";
import ResetPassword from "./pages/AuthPages/Reset/ResetPassword";
import CheckReset from "./pages/AuthPages/Reset/CheckReset";
import ChangePassword from "./pages/AuthPages/Reset/ChangePassword";
import Verify from "./pages/AuthPages/Verify/Verify";
import VerifySuccess from "./pages/AuthPages/Verify/VerifySuccess";
import StoreSetup from "./pages/StorePages/StoreSetup";
import UserStores from "./pages/StorePages/UserStores";
import { Toaster } from "sonner";
import { useEffect } from "react";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import { Helmet } from "react-helmet";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <>
      {import.meta.env.VITE_ENV !== "production" && (
        <Helmet>
          <meta name="robots" content="noindex, nofollow" />
        </Helmet>
      )}
      <ScrollToTop />
      <Routes>
        <Route index element={<LandingPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/verify" element={<Verify />} />
        <Route path="/verify/:key" element={<VerifySuccess />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/privacy_policy" element={<Privacy />} />
        <Route path="/terms_conditions" element={<Terms />} />
        <Route path="/mail-reset" element={<CheckReset />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route
          path="/password-reset/:uid/:token"
          element={<ChangePassword />}
        />
        <Route path="/add-store" element={<StoreSetup />} />
        <Route path="/my-stores" element={<UserStores />} />
      </Routes>
      <Toaster richColors position="top-right" />
    </>
  );
}

export default App;
